export const COMMUNITY_TYPE = 'communities';
export const HOMES_TYPE = 'homesForSale';
